import React from 'react';

import { Chip, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ImageAvatar } from 'components/Avatar';
import { ListCard } from 'components/Card';

import { useAuth } from 'lib/auth';
import { paths } from 'routes';

import { SupplierStarButton } from './SupplierStarButton';

const getFirstSentence = (text) => {
  if (!text) return '';
  const firstSentenceMatch = text.match(/[^.!?]+[.!?]/);
  return firstSentenceMatch ? firstSentenceMatch[0].trim() : text.trim();
};

export const SupplierListItem = ({
  company_id,
  name,
  country,
  description,
  square_logo_url,
  slug,
  is_starred,
  competence_areas = [],
  onStarChange,
}) => {
  const { account } = useAuth();

  const supplierUrl = account.super_admin
    ? paths.suppliersDetailsView(company_id)
    : slug?.length > 0 ? paths.public.companyPublicProfile('supplier', slug) : '';

  const content = (
    <Stack direction="row" gap={2} alignItems="center" flex="1 0 0">
      <ImageAvatar img={square_logo_url || ''} name={name || ''} />
      <Stack flex="1 0 0">
        <Typography
          variant="h5"
          sx={{
            fontSize: '1.375rem',
            fontWeight: 600,
            lineHeight: 'normal',
            color: 'text.black',
          }}
        >
          {name}
        </Typography>
        {country && (
          <Typography variant="body3" sx={{ color: 'text.secondary' }}>
            {country}
          </Typography>
        )}
        <Typography
          variant="body3"
          sx={{
            fontWeight: 400,
            color: 'text.list',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            overflow: 'hidden',
          }}
        >
          {getFirstSentence(description)}
        </Typography>
      </Stack>
    </Stack>
  );

  return (
    <ListCard
      addDefaultStyling={false}
      sx={{
        borderRadius: 1,
        borderColor: 'border.jobAd',
        flexDirection: 'row',
        px: 2,
        py: 2,
        gap: 2,
        boxShadow: 'none',
      }}
    >
      <Stack gap={1.5} flex="1 0 0">
        {supplierUrl ? (
          <Link component={RouterLink} to={supplierUrl} color="inherit" underline="none">
            {content}
          </Link>
        ) : content}
        {competence_areas.length > 0 && (
          <Stack direction="row" gap={1} flexWrap="wrap">
            {competence_areas.map((area) => (
              <Chip key={area.id} label={area.name} size="small" />
            ))}
          </Stack>
        )}
      </Stack>
      <SupplierStarButton
        companyID={company_id}
        isStarred={is_starred}
        onChange={onStarChange}
        sx={{ alignSelf: 'flex-start', mt: -1, mr: -1 }}
      />
    </ListCard>
  );
};
